/**
 * @fileoverview Global UI constants used throughout the application shell.
 * Feature-specific constants are colocated with their respective features.
 *
 * @see src/config/kanban.ts for Kanban-related constants
 * @see src/features/admin/data/shared/constants.ts for admin field constants
 */

// ============================================================================
// UI Dimensions
// ============================================================================

/** Drawer widths in pixels */
export const DRAWER_WIDTH = {
  BOOKMARKS: 350,
  TAGS: 250,
} as const;

/** Loading spinner sizes in pixels */
export const SPINNER_SIZE = {
  SMALL: 20,
  DEFAULT: 40,
  LARGE: 60,
} as const;

/** Floating action button positioning constants in pixels */
export const FAB_POSITION = {
  SIZE: 56,
  BOTTOM: 24,
  RIGHT: 24,
  GAP: 16,
} as const;

/** Speed Dial vertical offset: sits above the page-level FAB */
export const SPEED_DIAL_BOTTOM = FAB_POSITION.BOTTOM + FAB_POSITION.SIZE + FAB_POSITION.GAP;

/** Document title suffix used by every page `<title>`. */
export const APP_DOCUMENT_HOST = 'toolpad.keithwalsh.eu';

/** Builds a tab title in the form `{page} | toolpad.keithwalsh.eu`. */
export function documentTitle(page: string): string {
  return `${page} | ${APP_DOCUMENT_HOST}`;
}